// extracted by mini-css-extract-plugin
export default {"title":"jwLbpKbGD7u2j2NAmms6","card":"QygNyr8xKDK3e0u3gS6A","card-title":"p2NzxLeGyTW1fQoyUx0E","cardTitle":"p2NzxLeGyTW1fQoyUx0E"};